import Api from "./Api";

class CalculationTableService {
    get = (duplicate, id) => {
        return Api().get(`calculation`, {
            params: { duplicate, id }
        });
    };
    put = calculationData => {
        return Api().put("calculation", {
            id: calculationData.id,
            index: calculationData.index,
            formula: calculationData.formula,
            culture: calculationData.culture,
            sensor_high: calculationData.sensor_high,
            sensor_low: calculationData.sensor_low,
            soil_type: calculationData.soil_type,
            countries: calculationData.countries,
            date_from: calculationData.date_from,
            date_to: calculationData.date_to,
            rec: calculationData.recommendation
        });
    };
    post = async calculationData => {
        calculationData = {
            id: calculationData.id,
            index: calculationData.index,
            formula: calculationData.formula,
            culture: calculationData.culture,
            countries: calculationData.countries,
            sensor_high: calculationData.sensor_high,
            sensor_low: calculationData.sensor_low,
            soil_type: calculationData.soil_type,
            date_from: calculationData.date_from,
            date_to: calculationData.date_to,
            rec: calculationData.recommendation,
            duplicate: calculationData.duplicate
        };
        return await Api().post("calculation", calculationData);
    };

    delete = (calculation_id, recommendation_id) => {
        return Api().delete("calculation", {
            params: { calculation_id, recommendation_id }
        });
    };

    refresh = id => {
        return Api().get(`calculation/${id}/refresh`);
    };

    email() {
        return Api().get(`/calculation/email`);
    }
    downloadCalculationsCSV() {
        return Api().get(`/calculation/download`);
    }
}

export default new CalculationTableService();
